import { ASK_RECOVER_PASSWORD, RESET_RECOVER_PASSWORD } from '../types';
import AuthenticationService from '../../../../services/authentication-service';

const askRecoverPassword = email => async dispatch => {
  try {
    const { errors } = await AuthenticationService.recoverPassword(email);
    if (errors && errors.length) {
      throw errors;
    }
    dispatch({ type: ASK_RECOVER_PASSWORD });
  } catch (error) {
    // VOID
  }
};

const resetRecoverPassword = () => dispatch => {
  dispatch({ type: RESET_RECOVER_PASSWORD });
};

export { askRecoverPassword, resetRecoverPassword };
